import shared from "./base.module";
import { connect as userApi } from "../../../api/user.api";
import defaultUser, { connectUserRoles } from "@lab/meta/user";
import { HospitalUser } from "@lab/types/users";

const state = {
	...shared.state,
	config: {
		calloutrequests: false,
		meetingsenabled: false,
		sitetourrequests: false,
		searchresultsview: "",
		searchresultssort: "",
		userdefaultgroup: 0
	},
	groups: [],
	hospital: {
		id: 0,
		name: null
	},
	user: { ...defaultUser, role: "connect-case-manager" }
};

const getters = {
	...shared.getters,
	groups: (state, getters, rootState, rootGetters) => {
		const hospitals = rootGetters["hospitalsModule/hospitals"] || [];
		const groups = state.groups.map((g) => {
			const hospital = hospitals.find((h) => h.id === g.hospital.id);
			return {
				id: g.id,
				hospital: {
					id: hospital.id,
					name: hospital.name
				},
				name: g.name
			};
		});
		return groups;
	},
	hospital: (state) => {
		const { id, name } = state.hospital;
		return id ? { id, name } : null;
	},
	roles: (_) => connectUserRoles,
	user: (state, getters) => {
		return {
			...state.user,
			config: getters.config,
			groups: getters.groups,
			hospital: getters.hospital,
			dashboards: state.dashboards
		} as HospitalUser;
	}
};

const actions = {
	...shared.actions,
	async prepare({ commit }, user) {
		console.log("prepare:user:", user)
		const { id } = user;
		commit("SET_USER", user);

		// Set user hospitial
		const hospital = await userApi.hospital.get(id);

		commit("SET_HOSPITAL", {
			id: hospital.id,
			name: hospital.name
		});

		// Set user groups
		const groups = (await userApi.groups.get(id)) || [];

		commit(
			"SET_GROUPS",
			groups.map((group) => ({
				id: group.id,
				name: `${group.name}`,
				hospital: {
					id: group.hospitalid,
					name: ""
				}
			}))
		);

		const dashboards = await userApi.dashboards.get(id);
		commit("SET_DASHBOARDS", dashboards || []);

		const config = await userApi.config.get(id);
		commit("SET_CONFIG", config);
	}
};

const mutations = {
	...shared.mutations,
	SET_GROUPS(state: any, groups) {
		state.groups = groups;
	},
	SET_HOSPITAL(state: any, hospital) {
		state.hospital = hospital;
	},
	RESET_USER(state: any) {
		console.log("RESET_USER:", state)
		state.user = { ...defaultUser, role: "connect-case-manager" };
		state.groups = [];
		state.hospital = {
			id: 0,
			name: null
		};
		state.config = {
			calloutrequests: false,
			meetingsenabled: true,
			sitetourrequests: false,
			searchresultsview: "",
			searchresultssort: "",
			userdefaultgroup: 0
		};
	},
	updateGroups(state, groups) {
		state.groups = groups;
	},
	updateHospital(state, hospital) {
		state.hospital = hospital;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
